import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TipoProcessoDocumentoLocalEdicaoComponent } from './tipo-proc-doc-loc-edicao/tipo-proc-doc-loc-edicao.component';
import { TipoProcessoDocumentoLocalListaComponent } from './tipo-proc-doc-loc-lista/tipo-proc-doc-loc-lista.component';

const routes: Routes = [
  {
    path: 'tipoProcessoDocumentoLocal/listar',
    component: TipoProcessoDocumentoLocalListaComponent,
    data: { titulo: 'Lista os tipos de processo documento locais' },
  },
  {
    path: 'tipoProcessoDocumentoLocal/edicao/:id',
    component: TipoProcessoDocumentoLocalEdicaoComponent,
    data: { titulo: 'Edição de tipos de processo documento locais' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TipoProcessoDocumentoLocalRoutingModule {}
